import { encryptTransform } from 'redux-persist-transform-encrypt';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'bit-d',
  storage,
  transforms: [
    encryptTransform({
      secretKey: '74dpVYdU53',
      onError: (error) => {
        // eslint-disable-next-line no-console
        console.log(error);
      },
    }),
  ],
  whitelist: ['auth'],
};

export { persistConfig };
